'use strict';

import {EwSiteApp} from "../../app/ewsiteapp.js";

import {ContractsListCtrl} from "./contractslistctrl.js";
EwSiteApp.controller('ContractsListCtrl', ["$scope", "$http", "$filter", "$timeout", "$locale", "jsDataService", ContractsListCtrl]);

import {ContractInfoCtrl} from "./contractinfoctrl.js";
EwSiteApp.controller('ContractInfoCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", ContractInfoCtrl]);

import {DS1GeneralCtrl} from "./ds1generalctrl.js";
EwSiteApp.controller('DS1GeneralCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", DS1GeneralCtrl]);
import {DS2ParticipantsCtrl} from "./ds2participantsctrl.js";
EwSiteApp.controller('DS2ParticipantsCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", DS2ParticipantsCtrl]);
import {DSItemCtrl} from "./dsitemctrl.js";
EwSiteApp.controller('DSItemCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", DSItemCtrl]);
import {DS42PaymentsCtrl} from "./ds42paymentsctrl.js";
EwSiteApp.controller('DS42PaymentsCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", DS42PaymentsCtrl]);
import {DS43RecoveriesCtrl} from "./ds43recoveriesctrl.js";
EwSiteApp.controller('DS43RecoveriesCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", DS43RecoveriesCtrl]);

import {ContractPreambleCtrl} from "./contractpreamblectrl.js";
EwSiteApp.controller('ContractPreambleCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", ContractPreambleCtrl]);

import {AnnexPdfCtrl} from "./annexpdfctrl.js";
EwSiteApp.controller('AnnexPdfCtrl', ["$scope", "$filter", "$mdDialog", "jsDataService", "notify", AnnexPdfCtrl]);

import {PdfGenerateCtrl} from "./pdfgeneratectrl.js";
EwSiteApp.controller('PdfGenerateCtrl', ["$scope", "$http", "notify", PdfGenerateCtrl]);

import {ContractsChecklistsCtrl} from "./contractschecklistsctrl.js";
EwSiteApp.controller('ContractsChecklistsCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", ContractsChecklistsCtrl]);

import {ChecklistsCtrl} from "./checklistsctrl.js";
EwSiteApp.controller('ChecklistsCtrl',  ["$scope", "$filter", "$timeout", "$mdDialog", "jsDataService", "notify", ChecklistsCtrl]);

import {OtherAnnexesCtrl} from "./otherannexctrl.js";
EwSiteApp.controller('OtherAnnexesCtrl',  ["$scope", "$filter", "$timeout", "$mdDialog", "jsDataService", "notify", OtherAnnexesCtrl]);

